import { z } from 'zod';

/** ISO-8601 timestamp with timezone, e.g. 2026-09-16T12:00:00Z. */
export const isoDatumTijdSchema = z.iso.datetime({ offset: true });

/** WGS84 latitude/longitude pair. Coordinates are plain columns; there is no PostGIS. */
export const puntSchema = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
});
export type Punt = z.infer<typeof puntSchema>;

/** Bounding box as [west, south, east, north]. */
export const bboxSchema = z.tuple([z.number(), z.number(), z.number(), z.number()]);
export type Bbox = z.infer<typeof bboxSchema>;

export const PAGINATIE_STANDAARD_LIMIET = 50;
export const PAGINATIE_MAX_LIMIET = 500;

/**
 * Envelope for every paginated list endpoint.
 * `volgendeCursor` is null on the last page; `totaal` is only counted on the
 * first page (no cursor) and is null afterwards.
 */
export function pagedSchema<T extends z.ZodType>(item: T) {
  return z.object({
    data: z.array(item),
    volgendeCursor: z.string().nullable(),
    limiet: z.number().int(),
    totaal: z.number().int().nonnegative().nullable(),
  });
}

export type Paged<T> = {
  data: T[];
  volgendeCursor: string | null;
  limiet: number;
  totaal: number | null;
};

/** One field-level validation problem inside an ApiError. */
export const apiErrorDetailSchema = z.object({
  pad: z.string(),
  bericht: z.string(),
});
export type ApiErrorDetail = z.infer<typeof apiErrorDetailSchema>;

/**
 * Uniform error body for /api/v1. `foutcode` is machine-readable and stable,
 * `bericht` is the Dutch message the UI may show directly.
 */
export const apiErrorSchema = z.object({
  statusCode: z.number().int(),
  foutcode: z.string(),
  bericht: z.string(),
  details: z.array(apiErrorDetailSchema).optional(),
  pad: z.string().optional(),
  tijdstip: isoDatumTijdSchema,
});
export type ApiError = z.infer<typeof apiErrorSchema>;
